import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface AppDialogConfig {
  title: string;
  text: string;
  closeLabel?: string;
  actionLabel?: string;
  destructive?: boolean;
  presentation?: "dialog" | "sheet";
  action?: () => void;
}

@Injectable({
  providedIn: "root"
})
export class DialogService {
  private readonly dialogSubject = new BehaviorSubject<AppDialogConfig>(null);
  public readonly dialog$ = this.dialogSubject.asObservable();

  public alert(config: AppDialogConfig): void {
    this.dialogSubject.next(config);
  }

  public close(): void {
    this.dialogSubject.next(null);
  }
}
